var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white",
  fillOpacity: 0.01
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 11,
  width: 32,
  height: 26,
  rx: 2,
  stroke: "#1E293B",
  strokeWidth: 4
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 24,
  r: 6,
  fill: "#F43F5E",
  stroke: "#1E293B",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M36 29L44 33V15L36 19",
  stroke: "#1E293B",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgReactubeLogoCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactubeLogoCamera);
export default __webpack_public_path__ + "static/media/reactube-logo-camera.35b43e3ebdddabbc7636edd9c66f6abc.svg";
export { ForwardRef as ReactComponent };